import { FaBell } from "react-icons/fa";
import Modal from "../modal/modal";
import { NOTIF_LINK_MAP, formatRelativeTime, getPriorityBadgeClass } from "./notification_utils";

/**
 * View section — read-only detail popup for a single notification.
 * Pulled out of notifications.jsx so the "view" concern lives on its own,
 * separate from the list page and the "create announcement" flow.
 */
const NotificationDetailModal = ({ notif, onClose, loading = false }) => {
  if (!notif) return null;

  return (
    <Modal title={notif.title} icon={<FaBell />} onClose={onClose} size="md">
      <div className="notif-detail-modal">
        <div className="detail-row">
          <span className="detail-label">Priority:</span>
          <span className={getPriorityBadgeClass(notif.priority)}>
            {notif.priority_display}
          </span>
        </div>

        {notif.sender_name && (
          <div className="detail-row">
            <span className="detail-label">Sender:</span>
            <span>{notif.sender_name}</span>
          </div>
        )}

        <div className="detail-row">
          <span className="detail-label">Time:</span>
          <span>
            {formatRelativeTime(notif.created_at)} ( {new Date(notif.created_at).toLocaleString()} )
          </span>
        </div>

    
        <div className="detail-body-box">
          <h4>Message Body</h4>
          <p>
            {loading
              ? "Loading message…"
              : notif.message
              ? notif.message
              : "No message text was provided for this notification."}
          </p>
        </div>

        {notif.related_object_type && NOTIF_LINK_MAP[notif.related_object_type] && (
          <div className="modal-footer-actions">
            <a
              href={NOTIF_LINK_MAP[notif.related_object_type]}
              className="primary-btn"
              onClick={onClose}
            >
              Go to Related Module
            </a>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default NotificationDetailModal;